import { Component } from 'js-component-framework';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default class Carousel extends Component {
  constructor(config) {
    super(config);

    const { slider, gallery } = this.children;
    const { slickOptions } = this.options;

    // Get the first item from each NodeList.
    const [sliderEl] = slider;
    const [galleryEl] = gallery;

    if (null !== sliderEl) {
      const $slider = $(slider);
      $slider.slick(slickOptions);
    }

    if (null !== galleryEl) {
      const $gallery = $(gallery);
      $gallery.slick(slickOptions);

      // Collect elements to hide.
      const buttons = galleryEl.querySelectorAll('button');
      const shouldBeHidden = [...buttons, galleryEl];

      // Hide them all.
      for (let i = 0; i < shouldBeHidden.length; i += 1) {
        shouldBeHidden[i].setAttribute('aria-hidden', 'true');
      }
    }
  }
}
